import { JobListing } from '~/types/hlx/jobListing';
import { LABOR_REQ_TYPE_OPTIONS } from '../../../msaas-listing/wizard-steps/labor-metrics/constants';
import { LaborMetricsFormValues } from './types';

export const transformApiToLaborMetricsForm = (listing: JobListing): LaborMetricsFormValues => {
  return {
    id: listing.detail?.id,
    jobListingId: listing.id,
    startDate: listing.detail?.startDate || '',
    endDate: listing.detail?.endDate || '',
    numOfShifts: listing.detail?.numOfShifts || 0,
    hoursPerShift: listing.detail?.hoursPerShift || 0,
    minRvusPerShift: listing.detail?.minRvusPerShift || null,
    laborReqType:
      LABOR_REQ_TYPE_OPTIONS.find(
        (option: { value: string }) => option.value === listing.detail?.laborReqType
      ) || LABOR_REQ_TYPE_OPTIONS[0],
  };
};
